import React from 'react'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import { Button } from '@/components/ui'
import { ECommonRoute } from '@/types'
import { formatLocalizedString } from '@/utils/formatUtils'
import { FundingBannerResult } from '../FundingBannerResult'
import { FINANCING_MANAGER_PHONE } from './constants'
import { messages } from './messages'
import type { TFundingBannerErrorProps } from './types'
import './styles.scss'

export const FundingBannerError = ({ onResetStep }: TFundingBannerErrorProps) => {
  return (
    <FundingBannerResult
      glassMorphIcon="red/error"
      title={messages.title}
      subTitle={
        <>
          <div>{messages.subTitle.tryAgain}</div>
          <div>
            {formatLocalizedString(messages.subTitle.phone, {
              Link: text => (
                <CommonLink url={ECommonRoute.feedback} className="underline underline_green color_green">
                  {text}
                </CommonLink>
              ),
              Phone: text => (
                <CommonLink url={`tel:${FINANCING_MANAGER_PHONE}`} className="fundingBannerError__phone">
                  {text}
                </CommonLink>
              ),
            })}
          </div>
        </>
      }
      buttons={
        <Button className="fundingBannerError__button" onClick={onResetStep} modifiers={['green']}>
          {messages.buttons.close}
        </Button>
      }
    />
  )
}
